export enum BadgeColorEnum {
  info = 0,
  success = 1,
  danger = 2,
  warning = 3,
  primary = 4,
  secondary = 5,
  dark = 6,
}
